import { memo } from 'react';
import { Box, Typography } from '@mui/joy';

import AdaptivePage from 'components/AdaptivePage';
import AddNoteButton from 'components/AddNoteButton';
import PlusButton from 'components/PlusButton';

import { CopilotUtilityBar } from 'widgets/Copilot';

import CopilotInputConnector from './ui/CopilotInputConnector';
import InfoToolbar from './ui/InfoToolbar';

const Start = () => {
  return (
    <AdaptivePage
      hasTopBar
      desktopHeaderRightPanel={
        <CopilotUtilityBar
          minWidth="calc(var(--panels-ask-right-width) + 13px)"
          left={null}
          right={
            <>
              <AddNoteButton />
              <PlusButton />
            </>
          }
        />
      }
      bodyMaxWidth={1152}
      paddingHorizontalScheme={{ 320: 16 }}
    >
      <Box display="flex" flex={1} flexDirection="column" justifyContent="center" pb={10}>
        <Typography textColor="text.primary" fontSize={45} fontWeight={400} lineHeight={1.25} my={3} textAlign="center">
          Intelligent Knowledge Interface
        </Typography>
        <Box display="flex" flexDirection="column" alignItems="stretch" gap={4}>
          <CopilotInputConnector />
          <InfoToolbar width="90%" />
        </Box>
      </Box>
    </AdaptivePage>
  );
};

export default memo(Start);
